import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const { pathname } = useLocation();
  const isEnglish = pathname === '/en' || pathname.startsWith('/en/');
  return (
    <div className="flex h-screen flex-col items-center justify-center px-5 sm:px-6 lg:px-8 text-center">
      <p className="text-6xl font-semibold text-gray-200">404</p>
      <h1 className="mt-6 text-2xl font-semibold md:text-3xl">{isEnglish ? 'Page not found' : 'ページが見つかりません'}</h1>
      <Link className="mt-8 rounded bg-[#917c50] px-6 py-3 text-white" to={isEnglish ? '/en' : '/'}>{isEnglish ? 'Return to English home' : 'ホームへ戻る'}</Link>
    </div>
  );
}
